import WatchedDeviantsBox from './WatchedDeviantsBox';
import WatchedDeviantsBoxWide from './WatchedDeviantsBoxWide';
import { watchedDeviantsContainerCreator } from './WatchedDeviants.container';
import { WATCHER_IDS_STREAM, WATCHING_IDS_STREAM } from '../../../streams';

const WatchersBox = watchedDeviantsContainerCreator(WATCHER_IDS_STREAM)(
  WatchedDeviantsBox
);
const WatchingBox = watchedDeviantsContainerCreator(WATCHING_IDS_STREAM)(
  WatchedDeviantsBox
);

const WatchersBoxWide = watchedDeviantsContainerCreator(WATCHER_IDS_STREAM)(
  WatchedDeviantsBoxWide
);
const WatchingBoxWide = watchedDeviantsContainerCreator(WATCHING_IDS_STREAM)(
  WatchedDeviantsBoxWide
);

export { WatchersBox, WatchingBox, WatchersBoxWide, WatchingBoxWide };
